// import Lottie from 'lottie-react';

import LogoImg from 'assets/img/new-logo.svg';

// const santa = require('../../assets/lottie/santa.json')

type LogoProps = {
  mobile?: boolean;
};

const Logo = ({ mobile }: LogoProps) => {
  let cssSanta = '-right-[90px] w-[180px] top-[2px]';
  let cssGorro = '-left-[25px] -top-1 w-[150px]';

  if (mobile) {
    cssSanta = '-right-10 w-[80px] -top-[2px]';
    cssGorro = '-left-2 -top-1 w-[60px]';
  }

  return (
    <div className="relative">
      <img src={LogoImg} alt="#JogaJunto BB" className="relative" />
      {/* <Lottie className={`absolute ${cssSanta} lg:-right-[140px] lg:top-0 lg:w-[280px]`} animationData={santa} loop={true} /> */}
    </div>
  );
};

export default Logo;
